import { Component, OnInit,ViewChild } from '@angular/core';
import { ReceiptService} from 'app/shared/services/receipt.service';
import { Receipt } from 'app/shared/types/receipt';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';


@Component({
  selector: 'app-receipt-list',
  templateUrl: './receipt-list.component.html',
  styleUrls: ['./receipt-list.component.css']
})
export class ReceiptListComponent implements OnInit {

  displayedColumns: string[] = ['receiptNo', 'paidDate', 'customer', 'invoiceNo','paidTotal','status','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  receipts : Receipt[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  constructor(
              private receiptService : ReceiptService, 
              private router : Router, 
              private route : ActivatedRoute, 
              private themeService: NbThemeService,
              private authService: AuthService,
             ) { }

  ngOnInit() {

    this.getAllReceipts();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
    
  }

  
  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='RECEIPT'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

    newButtonClick(){
    this.router.navigate(['../receipt'],{relativeTo : this.route});
    }


    getAllReceipts(){
    this.receiptService.getAll()
     .subscribe(
        (data) => {
                  this.receipts = data; 
                  this.dataSource = new  MatTableDataSource (this.receipts);  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;      
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  

       
       
     }
   

     viewDetailsButtonClick(receiptNo : string){     
        this.router.navigate(['../receipt'],{queryParams : {'receiptNo':receiptNo},relativeTo : this.route});       
     }



   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }



}
